/*
 * @Description:
 * @Autor: qibiao
 * @Email: qibiao0508@163.com
 * @Date: 2023-11-20 10:19:35
 * @LastEditors: qibiao
 * @LastEditTime: 2023-12-20 18:06:51
 */
// 配置环境 测试环境：dev || 正式环境：pro
const environment = 'pro'

// 接口地址
const PRO_SERVER_IP = 'https://api.tradeaider.com/'
const DEV_SERVER_IP = 'http://192.168.3.161:8187/'

// const SERVER_IP = process.env.NODE_ENV === 'production' ? PRO_SERVER_IP : DEV_SERVER_IP
const SERVER_IP = environment === 'pro' ? PRO_SERVER_IP : DEV_SERVER_IP

// 微信分享
// global.GET_WEIXIN_SIGN = `https://api.tradeaider.com/sell/wx_support/public_platform/sign`
global.GET_WEIXIN_SIGN = `https://api.tradeaider.com/mdddocumentary/we-chat/get-signature`

// 加密的skey
global.SKEY = 'shinyhub'

// 合作伙伴接口
const AGENT = environment === 'pro' ? `${SERVER_IP}partner/agent/` : `${SERVER_IP}agent/`

// 公共接口
const PUBLIC = environment === 'pro' ? `${SERVER_IP}partner/public/` : `${SERVER_IP}public/`

// 登录
global.AGENT_LOGIN = `${PUBLIC}agent_login`
// 提现接口
global.WITHDRAW =
  environment === 'pro' ? `${SERVER_IP}partner/agentUserWithdrawal/` : `${SERVER_IP}agentUserWithdrawal/`
// 合作伙伴
global.AGENT = `${AGENT}`

// 合作伙伴修改密码
global.AGENT_CHANGE_PASSWORD = `${AGENT}change_password`
